import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { WebClientSize } from "@faire/web-api--source/indigofair/data/WebClientSize";
var DEFAULT_CLIENT_SIZES = [
    WebClientSize.MOBILE,
    WebClientSize.TABLET,
    WebClientSize.DESKTOP,
    WebClientSize.XLARGE_DESKTOP,
    WebClientSize.WEB_CLIENT_SIZE_UNKNOWN
];
export var calculateNumUPLTComponentsPerClientSize = function(viewLayout) {
    var _obj;
    var numberOfComponentsPerClientSize = (_obj = {}, _define_property(_obj, WebClientSize.MOBILE, 0), _define_property(_obj, WebClientSize.TABLET, 0), _define_property(_obj, WebClientSize.DESKTOP, 0), _define_property(_obj, WebClientSize.XLARGE_DESKTOP, 0), _define_property(_obj, WebClientSize.WEB_CLIENT_SIZE_UNKNOWN, 0), _obj);
    viewLayout.content.forEach(function(section) {
        if (!section.is_required_for_interactivity || !section.column_section && !section.filterable_paginated_section) {
            return;
        }
        if (section.filterable_paginated_section) {
            DEFAULT_CLIENT_SIZES.forEach(function(clientSize) {
                numberOfComponentsPerClientSize[clientSize] += 1;
            });
        }
        if (section.column_section) {
            section.column_section.components.forEach(function(component) {
                if (!component.is_required_for_interactivity) {
                    return;
                }
                var clientSizes = component.viewports.length === 0 ? DEFAULT_CLIENT_SIZES : component.viewports;
                clientSizes.forEach(function(clientSize) {
                    numberOfComponentsPerClientSize[clientSize] += 1;
                });
            });
        }
    });
    return numberOfComponentsPerClientSize;
};
